import { render, staticRenderFns } from "./HistoricoReajusteIndicePreco.vue?vue&type=template&id=21da5087&scoped=true"
import script from "./HistoricoReajusteIndicePreco.vue?vue&type=script&lang=js"
export * from "./HistoricoReajusteIndicePreco.vue?vue&type=script&lang=js"
import style0 from "./HistoricoReajusteIndicePreco.vue?vue&type=style&index=0&id=21da5087&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da5087",
  null
  
)

export default component.exports